import React, { HTMLAttributes } from 'react';
import { useSelector } from 'react-redux';
import { View } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import {
  ImmutableEntity,
  ImmutableRootState,
} from '@uncinc/react-drupal-core/types';

import {
  getOverviewUrlFromMenu,
} from '../../../helpers';

import EntitiesHighlighted from '../../../components/EntitiesHighlighted';
import { ParagraphArticleHighlights as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphArticleHighlightsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphArticleHighlights: React.FC<ParagraphArticleHighlightsProps> = ({ entity }) => {
  const { t } = useTranslation();
  const paragraphArticleHighlights = entity.toJS();
  const title = paragraphArticleHighlights.field_title[0]?.value;
  const targetAudienceId = paragraphArticleHighlights.field_target_audience?.[0]?.target_id;
  const menu = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['menu', 'main']));
  const overviewUrl = getOverviewUrlFromMenu(menu, 'articles');

  return (
    <div className="ParagraphArticleHighlights">
      <EntitiesHighlighted
        title={title}
        link={overviewUrl}
        linkTitle={t('content_types.article.overview')}
      >
        <View
          classes="row"
          id="article"
          display="highlights"
          filters={targetAudienceId !== null ? {
            field_target_audiences_target_id: [targetAudienceId],
          } : null}
        />
      </EntitiesHighlighted>
    </div>
  );
};

export default ParagraphArticleHighlights;
